module.exports = __webpack_public_path__ + "static/media/santa-reliquia-coromoto-1450.981f36f2.jpg";